import React, { useMemo } from "react";
import { safeDynamicFunction } from "src/helpers/computeFunctionHelper";
import TablePreviewComponent from "src/modules/worksheet/components/blocks/renderers/AllInOne/renderEditor/ComponentsEditor/GenericTable/preview";

interface DataObject {
    data: any[];
    function?: string;
    mode?: "single" | "comparison";
}

interface TableData {
    cells: any[];
    border?: any;
    gap?: any;
    reorder?: any;
    swipable?: any;
    minMaxWidth?: any;
    minHeight?: any;
    align?: string;
    padding?: any;
    drawing?: { enabled: boolean };
    puzzle?: { enabled: boolean };
}

interface TablePreviewWrapperProps {
    dataObject: DataObject;
    showMeasures?: boolean;
    mainTableSelectionActive?: boolean;
    setTableData?: (data: any) => void;
}

const TablePreviewWrapper: React.FC<TablePreviewWrapperProps> = ({
    dataObject,
    showMeasures = false,
    mainTableSelectionActive = false,
    setTableData,
}) => {
    const transformedData = useMemo(() => {
        if (!dataObject?.data?.length) return [];

        try {
            if (dataObject.function) {
                // Create a safe function from the string
                const transformFn = new Function(
                    "data",
                    `{ return (${dataObject.function})(data)}`,
                );

                console.log(
                    "processedData----------",
                    dataObject.data,
                    transformFn,
                );
                const processedData = transformFn(dataObject.data);

                console.log("processedData----------", processedData);

                // Always return an array of tables, using mode to determine structure
                return dataObject.mode === "comparison"
                    ? processedData.map((table) => ({ cells: table }))
                    : { cells: processedData };
            }
            // If no transform function, return data in a format compatible with TablePreviewComponent
            return {
                cells: dataObject.data.map((row) =>
                    Array.isArray(row) ? row : [row],
                ),
            };
        } catch (error) {
            console.error("Error transforming data:", error);
            return [];
        }
    }, [dataObject]);

    console.log("transformedData", transformedData, dataObject);

    if (!transformedData) return null;

    const mode = dataObject.mode || "single"; // Determine mode from dataObject

    return (
        <div className="table-preview-wrapper">
            {mode === "single" ? (
                <div className="single-table-container">
                    <TablePreviewComponent
                        tableData={transformedData}
                        showMeasures={showMeasures}
                        mainTableSelectionActive={mainTableSelectionActive}
                    />
                    {setTableData && (
                        <button
                            className="select-table-button"
                            onClick={() => setTableData(transformedData)}
                        >
                            Select Table
                        </button>
                    )}
                </div>
            ) : (
                <div className="comparison-tables-container">
                    {transformedData.map((tableData, index) => (
                        <div key={index} className="comparison-table">
                            <div className="table-label">Table {index + 1}</div>
                            <TablePreviewComponent
                                tableData={tableData}
                                showMeasures={showMeasures}
                                mainTableSelectionActive={
                                    mainTableSelectionActive
                                }
                            />
                            {setTableData && (
                                <button
                                    className="select-table-button"
                                    onClick={() => setTableData(tableData)}
                                >
                                    Select Table {index + 1}
                                </button>
                            )}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default TablePreviewWrapper;
